/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import PdPlaylistIcon from 'icons/PdPlaylistIcon';

const messages = defineMessages({
  title: {id: 'navigation.pd-playlists'},
});

const PdPlaylistsItem = () => (
  <RouteLinkItem
    iconBefore={PdPlaylistIcon}
    route="midas/staff/pd-playlists"
    title={messages.title}
  />
);

export default PdPlaylistsItem;
